import type { AuthenticatedUser, PermissionLevel } from '../types/auth';

export function getPermission(
  user: AuthenticatedUser | null,
  resourceCode: string,
): PermissionLevel {
  if (!user) return 'None';
  return user.permissions[resourceCode] ?? 'None';
}

export function canView(
  user: AuthenticatedUser | null,
  resourceCode: string,
): boolean {
  const p = getPermission(user, resourceCode);
  return p === 'View' || p === 'Edit';
}

export function canEdit(
  user: AuthenticatedUser | null,
  resourceCode: string,
): boolean {
  return getPermission(user, resourceCode) === 'Edit';
}
